import React, { useState, useEffect } from 'react';
import { Link, Navigate, Route, Routes, useLocation } from 'react-router';

// Tab component
const Tab = ({ isActive, onClick, children }) => {
  return (
    {children}
  );
};

// Tabs container component
const CustomTabs = ({ tabs, url }) => {
  console.warn("tabs , url", tabs , url);
  
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const lastPathPart = pathParts[pathParts.length - 1];

  let selectedTab = lastPathPart.length ? tabs.find((tab) => tab.route === lastPathPart)?.key : tabs[0].key;

  const [activeTab, setActiveTab] = useState(selectedTab);

  // Update active tab when URL changes (handles browser back/forward navigation)
  useEffect(() => {
    const currentSelectedTab = lastPathPart.length ? tabs.find((tab) => tab.route === lastPathPart)?.key : tabs[0]?.key;
    if (currentSelectedTab && currentSelectedTab !== activeTab) {
      setActiveTab(currentSelectedTab);
    }
  }, [location.pathname, lastPathPart, tabs, activeTab]);


  const renderActiveTabContent = () => {
    const activeTabData = tabs.find((tab) => tab.key === activeTab);
    return activeTabData ? activeTabData.displayItem : null;
  };

  return (
    <>
    <div className="studentDashboardSidePannel Custom_Tabs_section">
      {tabs.map((tab) => (
        <Link
          key={tab.key}
          to={`${url}/${tab.route}`}
          className={`tab-link ${selectedTab === tab.key ? 'active' : ''}`}
          onClick={(e) => {
            setActiveTab(tab.key);
          }}
        >{tab.title}
        </Link>
      ))}
      </div>
      <div className='created-my-courses-container'>
        <Routes>
          <Route path={`/`} element={<Navigate to={`${url}/profile`} />} />
          {tabs.map((tab) => (
            <Route
              key={tab.key}
              path={tab.route}
              element={tab.displayItem}
            />
          ))}
        </Routes>
      </div>
      </>
  );
};

export default CustomTabs;